import React from "react";

import type { PdfState } from "../../../shared/types/worksheet";

import { t } from "i18n/i18n";
import { LegacyButton } from "mds/components/LegacyButton";
import { ChevronLeftIcon, ChevronRightIcon } from "mds/icons";

type PdfPageToolbarProps = {
  pdfState: PdfState;
  setPdfState: (pdfState: Partial<PdfState>) => void;
};

export const PdfPageToolbar: React.FC<PdfPageToolbarProps> = ({ pdfState, setPdfState }) => {
  const goToPrevPage = () => {
    setPdfState({ pageNumber: pdfState.pageNumber - 1 });
  };

  const goToNextPage = () => {
    setPdfState({ pageNumber: pdfState.pageNumber + 1 });
  };

  const prevButton = (
    <LegacyButton
      aria-label={t("common.previous")}
      disabled={pdfState.pageNumber <= 1}
      kind="secondary"
      size="s"
      iconOnly
      onClick={goToPrevPage}
    >
      <ChevronLeftIcon />
    </LegacyButton>
  );

  const nextButton = (
    <LegacyButton
      aria-label={t("common.next")}
      disabled={pdfState.pageNumber >= pdfState.totalPages}
      kind="secondary"
      size="s"
      iconOnly
      onClick={goToNextPage}
    >
      <ChevronRightIcon />
    </LegacyButton>
  );

  return (
    <div className="page-toolbar flex items-center gap-2">
      {prevButton}

      <span className="page-toolbar__label body-s text-black-tint-20">
        {t("page_toolbar.page_label", {
          page_number: pdfState.pageNumber,
          total_pages: pdfState.totalPages,
        })}
      </span>

      {nextButton}
    </div>
  );
};
